import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import ResearchService from '@service/industry-research';
import moIndex from '../../store/index';

const moIndustryChain = observable({
  chainArr: <any[]>[],
  categoryArr: <string[]>[],
  isCategory: false,
});

const getIndustryDistibution = action(async (res: any) => {
  const { industry } = moIndex;
  // const params = { industry: industry.code };
  // const res: any = await ResearchService.chainDistribution(params);
  let newResult: any[] = [];
  let arr: any[] = [];
  let newArr: any[] = [];
  let isCategory = false;

  if (isEmpty(res)) newResult = [];
  else newResult = res;

  res?.map((item: any) => {
    if (!arr.includes(item.chain) && item.chain) arr.push(item.chain);
  });
  if (!isEmpty(arr)) {
    isCategory = true;
    arr.map((cname: any) => {
      newArr.push({
        chain: cname,
        list: [],
        active: false,
        hover: false,
      });
    });
    newArr.map((item: any) => {
      res.map((child: any) => {
        if (child.chain === item.chain) {
          item.list.push({
            ...child,
            hover: false,
            active: false,
          })
        }
      });
    });

    newArr.map((item: any) => {
      item.list.map((child: any) => {
        if (child.industry_name === industry.name) {
          item.active = true;
          child.active = true;
        }
      });
    });
  } else {
    isCategory = false;
    newResult.map((item: any) => {
      newArr.push({
        ...item,
        hover: false,
        active: false,
      })
    });
    newArr.map((item: any) => {
      if (item.industry_name === industry.name) item.active = true;
    });
  }

  runInAction(() => {
    moIndustryChain.isCategory = isCategory;
    moIndustryChain.categoryArr = arr;
    moIndustryChain.chainArr = newArr;
  });
});

const initIndustryChain = action(() => {
  // getIndustryDistibution();
});

const hoverIndustry3 = action((industryName: any) => {
  const arr: any[] = cloneDeep(moIndustryChain.chainArr);

  arr.map((item: any) => {
    item.list.map((industry: any) => {
      if (industry.industry_name === industryName) {
        item.hover = true;
        industry.hover = true;
      }
    });
  });

  moIndustryChain.chainArr = arr;
});

const hoverIndustry2 = action((industryName: any) => {
  const arr: any[] = cloneDeep(moIndustryChain.chainArr);

  arr.map((item: any) => {
    if (item.industry_name === industryName) item.hover = true;
  });

  moIndustryChain.chainArr = arr;
});

const leaveIndustry3 = action((industryName: any) => {
  const arr: any[] = cloneDeep(moIndustryChain.chainArr);

  arr.map((item: any) => {
    item.list.map((industry: any) => {
      if (industry.industry_name === industryName) {
        item.hover = false;
        industry.hover = false;
      }
    });
  });

  moIndustryChain.chainArr = arr;
});

const leaveIndustry2 = action((industryName: any) => {
  const arr: any[] = cloneDeep(moIndustryChain.chainArr);

  arr.map((item: any) => {
    if (item.industry_name === industryName) item.hover = false;
  });

  moIndustryChain.chainArr = arr;
});

export default moIndustryChain;
export {
  initIndustryChain, getIndustryDistibution,
  hoverIndustry2, hoverIndustry3,
  leaveIndustry2, leaveIndustry3,
};
